import { Sparkles } from "lucide-react";
import { usePlanPrices } from "@/hooks/use-plan-prices";

interface PromoBannerProps {
  variant?: "compact" | "large";
}

/**
 * Banner global de promoção. Renderiza nada quando não há promo ativa.
 * Usar no topo de páginas (landing + AppLayout).
 */
export default function PromoBanner({ variant = "compact" }: PromoBannerProps) {
  const { promotion } = usePlanPrices();
  if (!promotion) return null;

  const endLabel = promotion.end_date
    ? new Date(promotion.end_date).toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "long",
      })
    : null;

  const durationText =
    promotion.duration_months != null
      ? `Válido por ${promotion.duration_months} mensalidade${promotion.duration_months > 1 ? "s" : ""}.`
      : "Válido para todas as mensalidades.";

  const isLarge = variant === "large";

  return (
    <div
      className={`w-full border-b border-primary/30 bg-primary/10 px-4 text-center text-foreground ${
        isLarge ? "py-3 text-[15px]" : "py-2 text-[12px]"
      }`}
    >
      <span className={`inline-flex items-center gap-2 ${isLarge ? "flex-wrap justify-center" : ""}`}>
        <Sparkles className={`text-primary ${isLarge ? "h-5 w-5" : "h-3.5 w-3.5"}`} />
        <strong className="font-medium text-primary">
          {promotion.label ?? "Promoção"} — {promotion.percent}% OFF
        </strong>
        <span className="text-muted-foreground">
          em todos os planos pagos{endLabel ? ` até ${endLabel}` : ""}. {durationText}
        </span>
      </span>
    </div>
  );
}
